'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _addNew = require('./addNew.html');

var _addNew2 = _interopRequireDefault(_addNew);

var _addNew3 = require('./addNew.controller');

var _addNew4 = _interopRequireDefault(_addNew3);

require('./addNew.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var addNewComponent = {
  bindings: {
    close: '&',
    dismiss: '&',
    resolve: '<'
  },
  template: _addNew2.default,
  controller: _addNew4.default,
  controllerAs: "vm"
};

exports.default = addNewComponent;


// WEBPACK FOOTER //
// ./client/app/components/dashboard/information/addNew/addNew.component.js